export default __webpack_public_path__ + "static/media/angelie2.06bb3424.jpg";